module.exports = __webpack_public_path__ + "img/f-thermometer-img3-2.de5b1edc.png";